import { useState } from 'react';
import { callApi } from '../api/callApi';
import { API_ENDPOINT, API_URL_2 } from '../api/constant';

interface UploadImageResult {
    uploadImage: (file: File) => Promise<string>;
    isUploading: boolean;
    error: string | null;
}

const useImageUpload = (): UploadImageResult => {
    const [isUploading, setIsUploading] = useState(false);
    const [error, setError] = useState<string | null>(null);

    const uploadImage = async (file: File): Promise<string> => {
        setIsUploading(true);
        setError(null);

        try {
            const formData = new FormData();
            formData.append('file', file);

            const response = await callApi(
                `${API_URL_2}${API_ENDPOINT.page}file-upload/upload`,
                {
                    data: formData,
                    method: 'POST',
                    multipart: true,
                }
            );

            return response.path;
        } catch (err: any) {
            setError(err.message || 'Unable to upload file. Please try again.');
            throw new Error(err.message || 'Upload failed');
        } finally {
            setIsUploading(false);
        }
    };

    return { uploadImage, isUploading, error };
};

export default useImageUpload;
